import { Injectable, OnInit } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as platform from 'platform';
import { environment } from '../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class AppInsightsService implements OnInit {
  private appInsights: ApplicationInsights;

  constructor(private msalService: MsalService, private http: HttpClient) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '8ed4017e-b8b5-4adb-b119-7da3bede1c9f',
        enableAutoRouteTracking: true, // Automatically track page views
        disableTelemetry: false, // Ensure telemetry is enabled
        loggingLevelConsole: 0,
      }
    });

    this.appInsights.loadAppInsights();
    // this.trackUser();
  }
  ngOnInit() {  }


  // Track authenticated user
 async trackUser() {
    const account: AccountInfo | null = this.msalService.instance.getActiveAccount();
    if (account) {
      this.appInsights.setAuthenticatedUserContext(account.username); // Sets user email as identifier
      this.trackLoginEvent(account.username);
      const clientInfo = this.getClientInfo();
      const clientIP = await this.getClientIP();
      const locationData = await this.getClientLocation();
      
      const userDetails = {
        timestamp_UTC: new Date().toISOString(),
        name: account?.name || '',
        itemType: 'customEvent',
        customDimensions: JSON.stringify({
          email: account?.username || "Dinesh.Kumar@harpercollins.com",
          loginTime: new Date().toISOString(),
          clientInfo: clientInfo.browser
        }),
        customMeasurements: JSON.stringify({ metric: "value" }),
        operation_Name: '/',
        operation_SyntheticSource: '',
        session_Id: account?.idTokenClaims?.sid || '',
        user_Id: account?.localAccountId || '',
        user_AuthenticatedId: account?.username || '',
        user_AccountId: account?.homeAccountId || '',
        application_Version: '',
        client_Type: 'Browser',
        client_Model: clientInfo.model,
        client_OS: clientInfo.os,
        client_IP: clientIP,
        client_City: locationData.city,
        client_StateOrProvince: locationData.region,
        client_CountryOrRegion: locationData.country,
        client_Browser: clientInfo.browser,
        cloud_RoleName: '',
        cloud_RoleInstance: '',
        appId: account?.idTokenClaims?.aud || '',
        appName: '/subscriptions/c10e2822-7464-4050-b33f-1d2e8a5341e4/resourcegroups/hcus-analyticspoc-rg/providers/microsoft.insights/components/hcus-wa-ui-app-dev',
        iKey: '8ed4017e-b8b5-4adb-b119-7da3bede1c9f',
        sdkVersion: 'javascript:3.3.5',
        itemCount: '1',
        ResourceId: '/subscriptions/c10e2822-7464-4050-b33f-1d2e8a5341e4/resourcegroups/hcus-analyticspoc-rg/providers/microsoft.insights/components/hcus-wa-ui-app-dev'
      };
        const insertUrl = `${environment.apiBaseUrl}/insert?db_name=v2`;

        // this.http.post('https://hcus-wa-chathcp-cp-api-hjhpbkaphzg6fea3.eastus-01.azurewebsites.net/insert', userDetails).subscribe(response => {
        this.http.post(insertUrl, userDetails).subscribe(response => {        }, error => {        });
  
  
      }
    }

  // Log login event
  trackLoginEvent(email: string) {
    this.appInsights.trackEvent({
      name: 'UserLogin',
      properties: {
        email: email,
        loginTime: new Date().toISOString().slice(0, 10), // YYYY-MM-DD
        clientInfo: navigator.userAgent
      }
    });
  }

  // Track custom events
  trackEvent(eventName: string, properties?: any) {
    this.appInsights.trackEvent({ name: eventName, properties });
  }

  // Track exceptions
  trackError(error: any) {
    this.appInsights.trackException({ exception: error });
  }

  // Track events with timing (for performance monitoring)
trackEventWithTiming(eventName: string, startTime: number, properties?: any) {
  const duration = Date.now() - startTime;

  // Create a properly formatted UTC timestamp for BigQuery (ISO 8601 format)
  const timestamp = new Date().toISOString();

  const enhancedProperties = {
    ...properties,
    duration_ms: duration,
    timestamp,  // UTC timestamp in ISO 8601 format
    status: 'pending',
  }; (properties) // Send to Application Insights
  this.appInsights.trackEvent(
    {
      name: eventName,
      properties: enhancedProperties,
      measurements: { duration },
    }
  );
}


  // Start timing for an operation
  startTiming(): number {
    return Date.now();
  }

  private getClientInfo() {    return {
      model: platform.product || 'other',
      os: platform.os?.family || '',
      browser: platform.name || '',
    };
  }
  private async getClientIP(): Promise<string> {
    try {
      const response = await fetch('https://api64.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {      return '';
    }
  }
  private async getClientLocation(): Promise<any> {
    try {
      const clientIp = await this.getClientIP();
      const response = await fetch(`https://ipapi.co/${clientIp}/json/`);
      return await response.json();
    } catch (error) {      return { city: '', region: '', country: '' };
    }
  }
}
